import React from "react";
import { useNavigate } from "react-router-dom";
import "./index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import { Button } from "@ts-digital/vrc";
import { TSDIGITAL_PORTALE_PUBLIC_URL } from "../../../config";
import { useSelector } from "react-redux";
import { useState } from "react";
import SimpleLoader from "../../general/loader/index";

const CustomAlert = props => {
  const { msg1, msg2, buttonText, connectionsText, isTsPayOnboarding, isTsPayAccountant,
    startOnboardingSession, isLoadingOnboardingSession, isStartedOnboarding,
    /* isOnboardingSessionsEmpty, */ isToBeConfirmedStatus, resendOnboardingMailAction,
    isLoadingResendOnboardingMail, continueOnboarding,isTsPayPackage, onSetBalanceModalVisibility, isDeadlinesView, isBusinessPerformance} = props;

  const navigate = useNavigate();
  const main = useSelector(state => state.main);

  const [alertVisibility, setAlertVisibility] = useState(true);

  const startOnboardingConditions = (isTsPayOnboarding && !isToBeConfirmedStatus && isStartedOnboarding)// && isOnboardingSessionsEmpty))
                                      || (isTsPayOnboarding && !isStartedOnboarding && !isToBeConfirmedStatus);

  const renderActivateTsPayButton = () => {
    return (
      isLoadingOnboardingSession || isLoadingResendOnboardingMail ?
        <SimpleLoader />
        :
        <Button onClick={() =>  startOnboardingConditions ? startOnboardingSession()
          : isStartedOnboarding && /* !isOnboardingSessionsEmpty && */ !isToBeConfirmedStatus ? continueOnboarding()
            : resendOnboardingMailAction()}
        kind="secondary"
        >
          <FormattedMessage id={buttonText} />
        </Button>
    );
  };

  const openPage = () => {    
    navigate("/landing-no-data",
      {  
        state: {
          notAuthorized: true
        }
      });
    localStorage.setItem("landingAuth", true);    
  };

  const openPageAccountant = () => {    
    navigate("/landing-no-tspay",
      { 
        state: {fromToast: true}
      });    
  };

  const tsPayOnboardingStyles = {
    top: 80,
    borderColor: isStartedOnboarding /* && !isOnboardingSessionsEmpty) */ || isToBeConfirmedStatus || isTsPayPackage || isTsPayAccountant || isBusinessPerformance ? "#fdb927" : "#005075",
    justifyContent: "space-between",
    display: alertVisibility ? "flex" : "none",
    position: "static",
    marginBottom: 10
  };

  return (
    <div className="alertContainer" style={isTsPayOnboarding || isTsPayPackage || isTsPayAccountant || isBusinessPerformance ? tsPayOnboardingStyles : null}>
      <div
        style={{ flexDirection: "row", display: "flex", alignItems: "center" }}
      >
        <FontAwesomeIcon
          icon={[ !isTsPayOnboarding ? "far" : "fas", !isTsPayOnboarding && !isTsPayAccountant ? "exclamation-circle" : (!isTsPayAccountant ? "info-circle" : "exclamation-triangle") ]}
          style={{
            color: !isTsPayOnboarding ? "rgb(253, 185, 39" : !isStartedOnboarding /* || isOnboardingSessionsEmpty) */ && !isToBeConfirmedStatus ? "#005075" : isToBeConfirmedStatus ? "#fdb927" : "#fdb927",
            height: "23px",
            marginRight: "30px"
          }}
        />
        <div className="text1" style={{marginRight: isTsPayOnboarding && 5}}>
          <FormattedMessage id={msg1} />
        </div>
        {(!isTsPayOnboarding || !isStartedOnboarding /* || isOnboardingSessionsEmpty */) && !isToBeConfirmedStatus && msg2 &&
          <div className="text2">
            <FormattedMessage id={msg2} />
          </div>
        }
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: !isTsPayOnboarding ? 20 : 30, marginLeft: 20, marginRight: isTsPayOnboarding && 30 }}>
        {buttonText && (isTsPayPackage || isTsPayAccountant)  && !isBusinessPerformance ? (
          <Button onClick={() => isTsPayPackage ? openPageAccountant() : isDeadlinesView ? onSetBalanceModalVisibility() : null} kind="secondary">
            <FormattedMessage id={buttonText} />
          </Button> )
          : !isTsPayPackage && !isBusinessPerformance ? (
            buttonText && !isTsPayOnboarding  && !isBusinessPerformance ? (
              <Button onClick={() => openPage()} kind="secondary">
                <FormattedMessage id={buttonText} />
              </Button> )
              : renderActivateTsPayButton()
          ) : null
        }
        {isTsPayOnboarding && (
          <FontAwesomeIcon
            icon={["far", "times"]}
            style={{
              fontSize: "16px",
              cursor: "pointer"
            }}
            onClick={() => setAlertVisibility(false)}
          />
        )
        }
        {connectionsText && (
          <a
            href={
              TSDIGITAL_PORTALE_PUBLIC_URL +
              "#/" +
              main.accountantIdSelected +
              "/connections/create/existingCompany/" +
              main.clientIdSelected
            }
            id="goToTSDigital"
            aria-label={"Link al portale TS Digital per la connessione"}
            tabIndex="0"
          >
            <Button kind="primary">
              <FormattedMessage id={connectionsText} />
            </Button>
          </a>
        )}
      </div>
    </div>
  );
};

export default CustomAlert;
